import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * O valor gravado aqui é injetado cru como `--custom-accent-color` no contador e no portal do
 * cliente, sem validação em nenhuma das camadas entre este form e o CSS. Hex sem `#` é uma
 * variável CSS válida mas uma cor inválida: a declaração que a usa é descartada e a barra
 * lateral do escritório fica transparente.
 *
 * O `minLength(7)`/`maxLength(7)` que existia aqui só media o tamanho de `#RRGGBB` — deixava
 * passar `002D72A` e qualquer outro lixo de sete caracteres.
 */
const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;

export const accentColorValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const accentColor = control.value;

    if (!accentColor) return null;

    if (!HEX_COLOR_PATTERN.test(accentColor)) return { invalidAccentColor: true };

    return null;
}

/**
 * Prefixa o `#` que o operador esqueceu. Só isso — corrigir o resto seria adivinhar o que ele
 * quis dizer, e o validator já barra o que sobrar.
 */
export function normalizeAccentColor(accentColor: string | null): string | null {
    if (!accentColor) return accentColor;

    const trimmed = accentColor.trim();

    if (!trimmed) return null;

    return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
}
